import { render, staticRenderFns } from "./ManageEmailTemplate.vue?vue&type=template&id=30064293&scoped=true"
import script from "./ManageEmailTemplate.vue?vue&type=script&lang=js"
export * from "./ManageEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30064293",
  null
  
)

export default component.exports